export default {
  rewards: {
    title: "報酬",
    claim: "受け取る",
    weeklyCashback: "週間キャッシュバック",
    weeklyCashbackDesc: "毎週の負けの一部を毎週返金します。",
    dailySpin: "デイリースピン",
    dailySpinDesc: "毎日ホイールを回して大きな賞品を獲得するチャンス。",
    invitationBonus: "招待ボーナス",
    invitationBonusDesc: "友達を招待して、参加ごとに報酬を獲得。",
    rebate: "リベート",
    rebateDesc: "勝ち負けに関わらず、すべてのベットでリベートを獲得。",
    bannerTitle: "報酬",
    bannerSubtitle: "タスクを完了して素晴らしい報酬を獲得しよう！",
    sectionTitle: "あなたの素晴らしい報酬",
    goNow: "今すぐ行く",
    historyReceived: "累計受取",
    todayReceived: "本日受取",
    cashbackDialog: {
      title: "ベットキャッシュバック",
      loading: "読み込み中...",
      empty: "キャッシュバックルールがありません",
      level: "レベル",
      amountRange: "金額範囲",
      rewardRate: "還元率",
      rewardCap: "還元上限",
    },
    cards: {
      checkin: {
        title: "デイリーチェックイン",
        subtitle: "ログインして毎日チェックイン",
        description: "プレイヤーの皆さん、毎日チェックインを忘れずに~",
      },
      cashback: {
        title: "キャッシュバック",
        subtitle: "プラットフォームのリベート報酬",
      },
      rescue: {
        title: "救済ボーナス",
        subtitle: "キャッシュゲームを3回プレイ",
        description: "破産したプレイヤーを救う救済資金",
      },
      task: {
        title: "タスク",
        subtitle: "プラットフォームタスクを完了",
        description: "プラットフォームのタスク",
      },
      balance: {
        title: "金庫",
        subtitle: "毎日の利息を獲得",
        description: "プラットフォームの金庫",
      },
      loan: {
        title: "ローンボーナス",
        subtitle: "簡単に借入",
        description: "プラットフォームの借入",
      },
    },
    checkIn: {
      dailySignIn: "デイリーチェックイン",
      totalRewards: "報酬合計",
      headlineDaysBefore: "",
      headlineDaysAfter: "日連続でチェックイン、",
      headlineTailCumulative: "1日抜けても大丈夫。",
      headlineTailDate: "1日抜けるとその日の報酬を失います。",
      headlineCumulative: "{days}日連続チェックインで大当たり、1日抜けても大丈夫。",
      headlineDate: "{days}日連続でチェックイン、1日抜けるとその日の報酬を失います。",
      headlineEmpty: "チェックインして報酬を獲得",
      title: "チェックイン",
      modeCumulative: "累計チェックイン",
      modeDate: "日付チェックイン",
      rewards: "報酬",
      signedIn: "チェックイン済",
      day: "{n}日目",
      loading: "読み込み中...",
      empty: "実施中のチェックインアクティビティはありません。",
      btnCheckIn: "チェックイン",
      btnSigned: "済み",
      btnLocked: "ロック中",
      claimSuccess: "チェックイン成功、報酬 {amount} {currency} が付与されました",
      claimFailed: "チェックインに失敗しました",
      alreadySigned: "本日は既にチェックイン済みです",
      notLogin: "先にログインしてください",
    },
  },
};
